import { Injector, ModelSignal } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { InputFormatType, NavigationOptionsType } from '@finxone-platform/shared/sys-config-types';
import { Subject } from 'rxjs';

/**
 * DI seam for the email/phone verify-button flows. The web frontend provides the concrete
 * implementation, which delegates to its form-widget verify-button action utilities. The
 * component injector is passed through so app-scoped services (e.g. `ActivatedRoute`) are
 * resolved against the calling component's context.
 */
export abstract class FieldVerificationService {
  abstract handleEmailVerification(
    injector: Injector,
    destroy$: Subject<void>,
    showEmailVerifyButton: ModelSignal<boolean>,
    widgetParentFormId: string,
    formGroup: FormGroup,
    formControlName: string,
  ): void;

  abstract handlePhoneVerification(
    injector: Injector,
    destroy$: Subject<void>,
    showPhoneVerifyButton: ModelSignal<boolean>,
    widgetParentFormId: string,
    formGroup: FormGroup,
    formControlName: string,
    countryCodeKey: string,
    attachToInput: boolean,
  ): void;

  abstract verifyEmailPhoneButton(
    injector: Injector,
    type: InputFormatType | undefined,
    widgetNavigationOptions: NavigationOptionsType,
    formControlName: string,
    parentFormID: string,
    nestedFormId: string,
    phoneNumberAttachToInput: boolean,
    countryCodeFormControl: AbstractControl<any, any> | null | undefined,
    mainFormControl: AbstractControl<any, any> | null | undefined,
    countryCodeFormControlName?: string | undefined,
  ): void;
}
